import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ContractListNavigation {
    contractIds: string[];
    returnTo: string;
    sourceListPath: string;
}

interface ContractProfileState {
    selectedView: string;
    contractId: string | null;
    listNavigation: ContractListNavigation | null;
}

const initialState: ContractProfileState = {
    selectedView: '/info',
    contractId: '',
    listNavigation: null,
};

const contractProfileSlice = createSlice({
    name: 'contractProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
        setContractId(state, action: PayloadAction<string | null>) {
            state.contractId = action.payload;
        },
        setContractListNavigation(state, action: PayloadAction<ContractListNavigation>) {
            state.listNavigation = action.payload;
        },
        clearContractListNavigation(state) {
            state.listNavigation = null;
        },
    },
});

export const { setSelectedView, setContractId, setContractListNavigation, clearContractListNavigation } = contractProfileSlice.actions;
export default contractProfileSlice.reducer;